import { observer } from "mobx-react-lite";
import React, { Fragment, useEffect, useState } from "react";
import { useStore } from "../../app/stores/store";
import agent from '../../app/api/agent';
import LoadingComponent from "../../app/layout/LoadingComponent";
import { List } from 'semantic-ui-react'
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import IconButton from '@material-ui/core/IconButton';
import EditIcon from '@material-ui/icons/Edit';
import DescriptionOutlinedIcon from '@material-ui/icons/DescriptionOutlined';
import { listRoles } from "../../app/models/Roles";
import EditarRoles from "./EditarRoles";

const useStyles = makeStyles({
    table: {
      minWidth: 650,
    },
  });

export default observer(function ListRoles() {
    const classes = useStyles();
    const {modalStore, RolesStore} = useStore();
    const {allRoles} = RolesStore;

    useEffect(() => {
        allRoles()
    }, [allRoles])
    return (
        <>
            <TableContainer>
                <Table className={classes.table} aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell></TableCell>
                            <TableCell></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                    {RolesStore.RolByCodigo.map((item:listRoles) => {
                        return (
                            <TableRow key={item.id}>
                                <TableCell>
                                    {item.name}
                                </TableCell>
                                <TableCell align="right">
                                    <IconButton aria-label="delete" onClick={() => {
                                        modalStore.openModal(<EditarRoles id={item.id} nombreRol={item.name} />, 'large' )
                                    }}>
                                        <EditIcon />
                                    </IconButton>
                                </TableCell>
                            </TableRow>
                        )
                    })}
                    </TableBody>
                </Table>
            </TableContainer>
        </>
    )
})